export default {
  namespaced: true,
  state: {
    selectedUserList: [],
  },
  mutations: {
    SAVE_SELECTED_USER_LIST(state, data) {
      state.selectedUserList = data;
    },
    CLEAR_SELECTED_USER_LIST(state) {
      state.selectedUserList = [];
    },
  },
  actions: {
    saveSelectedUserList({ commit }, data) {
      commit('SAVE_SELECTED_USER_LIST', data);
    },
    clearSelectedUserList({ commit }) {
      commit('CLEAR_SELECTED_USER_LIST');
    },
  },
};
